import { Route, Routes } from 'react-router-dom';
import EndUserStatusScreen from '../Screens/EndUserStatusScreen';
import TermsAndCondition from '../Screens/TermsAndConditions';
import PrivacyPolicy from '../Screens/PrivacyPolicy';
import RefundPolicy from '../Screens/RefundPolicy';
import HomeScreen from '../Screens/HomeScreen';
import DespatchKnowMore from '../Screens/DespatchKnowMore';
import PartnerKnowMore from '../Screens/PartnerKnowMore';
import AboutUs from '../Screens/AboutUs';
import ContactUs from '../Screens/ContactUs';
function Routers() {

    return (
        <Routes>
            <Route path="/" element={<HomeScreen />} />
            <Route path="/track" element={<EndUserStatusScreen />} />
            <Route path="/terms" element={<TermsAndCondition />} />
            <Route path="/policy" element={<PrivacyPolicy />} />
            <Route path="/refund" element={<RefundPolicy />} />
            <Route path="/despatch" element={<DespatchKnowMore />} />
            <Route path="/partner" element={<PartnerKnowMore />} />
            <Route path="/aboutus" element={<AboutUs />} />
            <Route path="/contactus" element={<ContactUs />} />

        </Routes>
    )
}

export default Routers;